<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">Recipe book</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li  class="nav-item" *ngIf="isAuthenticated">
          <a routerLinkActive="active" class="nav-link" [routerLink] = "['recipes']" >Recipes <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a routerLinkActive="active" class="nav-link" [routerLink] = "['shopping-list']">Shopping list</a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a routerLinkActive="active" class="nav-link" (click)="onLogout()" style="cursor: pointer;">Log out</a>
        </li>


      </ul>

      <ul class="navbar-nav nav-right">


        <li ngbDropdown class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
            Manage
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdown">
            <a ngbDropdownItem (click)="onSaveRecipes()" style="cursor: pointer;">Save</a>
            <a ngbDropdownItem (click)="onFetchRecipes()" style="cursor: pointer;">Fetch</a>
          </div>
        </li>
      </ul>
    </div>
  </nav> -->


  <nav class="navbar navbar-expand-lg navbar-light bg-light mb-3">
    <a class="navbar-brand" [routerLink]="'.'">Recipe Book</a>

    <!-- Step 3: Toggle the value of the property when the toggler button is clicked. -->
    <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
      &#9776;
    </button>

    <!-- Step 2: Add the ngbCollapse directive to the element below. -->
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
      <ul class="navbar-nav myNavList">
        <li class="nav-item">
          <!-- Step 4: Close the menu when a link is clicked. -->
          <a class="nav-link" routerLinkActive="active" [routerLink]= "['recipes']" (click)="isMenuCollapsed = true">Recipes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]= "['shopping-list']" (click)="isMenuCollapsed = true">Shopping list</a>
        </li>
        <li class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link" routerLinkActive="active" (click)="isMenuCollapsed = true" (click)="onLogout()" style="cursor: pointer;">Log out</a>
        </li>
      </ul>

      <!-- <ul class="navbar-nav nav-right">
        <li ngbDropdown class="nav-item" *ngIf="isAuthenticated">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
            Manage
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdown">
            <a ngbDropdownItem (click)="onSaveRecipes()" style="cursor: pointer;">Save</a>
            <a ngbDropdownItem (click)="onFetchRecipes()" style="cursor: pointer;">Fetch</a>
          </div>
        </li>
      </ul> -->

    </div>
  </nav>
